/* eslint-disable */
import { DocumentTypeDecoration } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
};

export enum AncapReportType {
  Commercial = 'commercial',
  Passenger = 'passenger'
}

export type AncapTestRecord = {
  __typename?: 'AncapTestRecord';
  ancapUrl: Scalars['String']['output'];
  gradingLabel?: Maybe<GradingLabel>;
  gradingYear?: Maybe<Scalars['String']['output']>;
  isAncapValid?: Maybe<Scalars['Boolean']['output']>;
  protocolVersion?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['Int']['output']>;
  ratingYear?: Maybe<Scalars['String']['output']>;
  reportType: AncapReportType;
  technicalReportUrl?: Maybe<Scalars['String']['output']>;
  testResults: Array<AncapTestResult>;
};

export type AncapTestResult = {
  __typename?: 'AncapTestResult';
  isassessed?: Maybe<Scalars['Boolean']['output']>;
  maxvalue?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  units?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type ExcludeFilter = {
  makedescription?: InputMaybe<Scalars['String']['input']>;
  modeldescription?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type GetVehicleInput = {
  makeid?: InputMaybe<Scalars['String']['input']>;
  modelid?: InputMaybe<Scalars['String']['input']>;
  vehicleid?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type GetVehiclesInput = {
  vehicleids: Array<Scalars['String']['input']>;
};

export type GetYearsInput = {
  make: Scalars['String']['input'];
  model: Scalars['String']['input'];
};

export enum GradingLabel {
  Basic = 'Basic',
  Bronze = 'Bronze',
  Gold = 'Gold',
  NotRecommended = 'NotRecommended',
  Platinum = 'Platinum',
  Silver = 'Silver'
}

export type MakeModel = {
  __typename?: 'MakeModel';
  make: MakeModelItem;
  models: Array<MakeModelItem>;
};

export type MakeModelItem = {
  __typename?: 'MakeModelItem';
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export type Query = {
  __typename?: 'Query';
  getAllMakesModels: Array<MakeModel>;
  getAllSafetyFeatures: Array<SafetyFeature>;
  getBatchVehicleDerivedFields: Array<VehicleDerivedFields>;
  getBatchVehicleOverrideFields: Array<VehicleOverrideFields>;
  getVehicle?: Maybe<VehicleSearchResult>;
  getVehicleAncapTestRecords?: Maybe<AncapTestRecord>;
  getVehicleComfortFeatures: Array<Maybe<VehicleComfortFeature>>;
  getVehicleCost?: Maybe<VehicleCostData>;
  getVehicleEcoData?: Maybe<VehicleEcoData>;
  getVehicleSafetyFeatures: Array<Maybe<VehicleSafetyFeature>>;
  getVehicleSafetyFieldsById?: Maybe<VehicleSafetyFields>;
  getVehicleSearchFilters: VehicleSearchFilters;
  getVehicles: Array<VehicleSearchResult>;
  getVehiclesWithFeature: Array<VehicleSearchResult>;
  getYears: Array<Scalars['Int']['output']>;
  searchVehicles: Array<VehicleSearchResult>;
};


export type QueryGetBatchVehicleDerivedFieldsArgs = {
  vehicleIds: Array<Scalars['ID']['input']>;
};


export type QueryGetBatchVehicleOverrideFieldsArgs = {
  vehicleIds: Array<Scalars['ID']['input']>;
};


export type QueryGetVehicleArgs = {
  input: GetVehicleInput;
};


export type QueryGetVehicleAncapTestRecordsArgs = {
  vehicleId: Scalars['ID']['input'];
};


export type QueryGetVehicleComfortFeaturesArgs = {
  vehicleId: Scalars['ID']['input'];
};


export type QueryGetVehicleCostArgs = {
  vehicleId: Scalars['ID']['input'];
};


export type QueryGetVehicleEcoDataArgs = {
  vehicleId: Scalars['ID']['input'];
};


export type QueryGetVehicleSafetyFeaturesArgs = {
  vehicleId: Scalars['ID']['input'];
};


export type QueryGetVehicleSafetyFieldsByIdArgs = {
  vehicleId: Scalars['ID']['input'];
};


export type QueryGetVehiclesArgs = {
  input: GetVehiclesInput;
};


export type QueryGetVehiclesWithFeatureArgs = {
  input: VehiclesWithFeatureInput;
};


export type QueryGetYearsArgs = {
  input: GetYearsInput;
};


export type QuerySearchVehiclesArgs = {
  input: VehicleSearchInput;
};

export type SafetyFeature = {
  __typename?: 'SafetyFeature';
  isrecommended: Scalars['Boolean']['output'];
  safetyfeaturecode: Scalars['String']['output'];
  safetyfeaturename: Scalars['String']['output'];
};

export type Vehicle = {
  __typename?: 'Vehicle';
  description: Scalars['String']['output'];
  makedescription: Scalars['String']['output'];
  modeldescription: Scalars['String']['output'];
  vehicleid: Scalars['String']['output'];
  year: Scalars['Int']['output'];
};

export type VehicleComfortFeature = {
  __typename?: 'VehicleComfortFeature';
  comfortfeaturecode?: Maybe<Scalars['String']['output']>;
  comfortfeaturename?: Maybe<Scalars['String']['output']>;
  vehicleid: Scalars['String']['output'];
};

export type VehicleCostData = {
  __typename?: 'VehicleCostData';
  estimatedrunningcost?: Maybe<Scalars['Int']['output']>;
  fuelconsumption?: Maybe<Scalars['String']['output']>;
  fueltype?: Maybe<Scalars['String']['output']>;
  vehicleid: Scalars['String']['output'];
};

export type VehicleDerivedFields = {
  __typename?: 'VehicleDerivedFields';
  derivedbodycode?: Maybe<Scalars['String']['output']>;
  derivedbodydescription?: Maybe<Scalars['String']['output']>;
  lifestyle?: Maybe<Scalars['String']['output']>;
  ratingprovider?: Maybe<Scalars['String']['output']>;
  vehicleid: Scalars['String']['output'];
};

export type VehicleEcoData = {
  __typename?: 'VehicleEcoData';
  airpollutionrating?: Maybe<Scalars['Float']['output']>;
  co2combined?: Maybe<Scalars['Int']['output']>;
  co2extraurban?: Maybe<Scalars['Int']['output']>;
  co2urban?: Maybe<Scalars['Int']['output']>;
  emissionstandard?: Maybe<Scalars['String']['output']>;
  energyconsumption?: Maybe<Scalars['Float']['output']>;
  fuelcombined?: Maybe<Scalars['Float']['output']>;
  fuelextraurban?: Maybe<Scalars['Float']['output']>;
  fuelurban?: Maybe<Scalars['Float']['output']>;
  greenhouserating?: Maybe<Scalars['Float']['output']>;
  kmrangeelectricwltp?: Maybe<Scalars['Int']['output']>;
  powerplanttype?: Maybe<Scalars['String']['output']>;
  vehicleid: Scalars['String']['output'];
};

export type VehicleOverrideFields = {
  __typename?: 'VehicleOverrideFields';
  imageoverride?: Maybe<Scalars['String']['output']>;
  isblacklisted?: Maybe<Scalars['Boolean']['output']>;
  ratingprovideroverride?: Maybe<Scalars['String']['output']>;
  vehicleid: Scalars['String']['output'];
};

export type VehicleSafetyFeature = {
  __typename?: 'VehicleSafetyFeature';
  isprimaryfeature?: Maybe<Scalars['Boolean']['output']>;
  isrecommended?: Maybe<Scalars['Boolean']['output']>;
  isstandard?: Maybe<Scalars['Boolean']['output']>;
  safetyfeaturecode?: Maybe<Scalars['String']['output']>;
  safetyfeaturename?: Maybe<Scalars['String']['output']>;
};

export type VehicleSafetyFields = {
  __typename?: 'VehicleSafetyFields';
  activeratingprovider?: Maybe<Scalars['String']['output']>;
  ancaptestyear?: Maybe<Scalars['Int']['output']>;
  safetyFeatures?: Maybe<Array<Scalars['String']['output']>>;
  stars?: Maybe<Scalars['Int']['output']>;
  vehicleid: Scalars['String']['output'];
};

export type VehicleSearchFilter = {
  __typename?: 'VehicleSearchFilter';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type VehicleSearchFilters = {
  __typename?: 'VehicleSearchFilters';
  bodyTypes: Array<VehicleSearchFilter>;
  makes: Array<VehicleSearchFilter>;
  recommendedSafetyFeatures: Array<VehicleSearchFilter>;
};

export type VehicleSearchInput = {
  bodyTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  excludeFilter?: InputMaybe<ExcludeFilter>;
  excludeVehicles?: InputMaybe<Array<Scalars['String']['input']>>;
  includeAllVariants?: InputMaybe<Scalars['Boolean']['input']>;
  includeNonRecommendable?: InputMaybe<Scalars['Boolean']['input']>;
  lifestyle?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  make?: InputMaybe<Array<Scalars['String']['input']>>;
  makeSlug?: InputMaybe<Array<Scalars['String']['input']>>;
  maxAncapYear?: InputMaybe<Scalars['Int']['input']>;
  maxPrice?: InputMaybe<Scalars['Int']['input']>;
  maxSafetyFeaturesCount?: InputMaybe<Scalars['Int']['input']>;
  maxYear?: InputMaybe<Scalars['Int']['input']>;
  minAncapYear?: InputMaybe<Scalars['Int']['input']>;
  minPrice?: InputMaybe<Scalars['Int']['input']>;
  minSafetyFeaturesCount?: InputMaybe<Scalars['Int']['input']>;
  minYear?: InputMaybe<Scalars['Int']['input']>;
  model?: InputMaybe<Array<Scalars['String']['input']>>;
  modelSlug?: InputMaybe<Array<Scalars['String']['input']>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  pPlaterApproved?: InputMaybe<Scalars['Boolean']['input']>;
  powerTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  price?: InputMaybe<Scalars['Int']['input']>;
  redbookSegment?: InputMaybe<Array<Scalars['String']['input']>>;
  safeCarsForFamilies?: InputMaybe<Scalars['Boolean']['input']>;
  safetyFeatures?: InputMaybe<Array<Scalars['String']['input']>>;
  starRating?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type VehicleSearchResult = {
  __typename?: 'VehicleSearchResult';
  activeratingprovider?: Maybe<Scalars['String']['output']>;
  ancaptestyear?: Maybe<Scalars['Int']['output']>;
  badgedescription?: Maybe<Scalars['String']['output']>;
  bodytype?: Maybe<Scalars['String']['output']>;
  costRating?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  ecoRating?: Maybe<Scalars['String']['output']>;
  enginedisplacement?: Maybe<Scalars['String']['output']>;
  featuresRating?: Maybe<Scalars['String']['output']>;
  fueltype?: Maybe<Scalars['String']['output']>;
  isbaseoption?: Maybe<Scalars['Boolean']['output']>;
  isblacklisted?: Maybe<Scalars['Boolean']['output']>;
  isrecommendable?: Maybe<Scalars['Boolean']['output']>;
  lifestyle?: Maybe<Array<Scalars['String']['output']>>;
  makedescription: Scalars['String']['output'];
  makeid: Scalars['String']['output'];
  makeslug?: Maybe<Scalars['String']['output']>;
  maxprice?: Maybe<Scalars['Int']['output']>;
  minprice?: Maybe<Scalars['Int']['output']>;
  modeldescription: Scalars['String']['output'];
  modelid: Scalars['String']['output'];
  modelslug?: Maybe<Scalars['String']['output']>;
  month: Scalars['String']['output'];
  photoId?: Maybe<Scalars['String']['output']>;
  pplatestatus?: Maybe<Scalars['String']['output']>;
  safecarforfamilies?: Maybe<Scalars['Boolean']['output']>;
  safetyRating?: Maybe<Scalars['String']['output']>;
  safetyfeatures?: Maybe<Array<Scalars['String']['output']>>;
  sequencenumber?: Maybe<Scalars['Int']['output']>;
  series?: Maybe<Scalars['String']['output']>;
  stars?: Maybe<Scalars['Int']['output']>;
  transmission?: Maybe<Scalars['String']['output']>;
  ucsrAggressivity?: Maybe<Scalars['Int']['output']>;
  ucsrDriver?: Maybe<Scalars['Int']['output']>;
  ucsrPrimarySafety?: Maybe<Scalars['Int']['output']>;
  vehicleid: Scalars['String']['output'];
  vfactssegment?: Maybe<Scalars['String']['output']>;
  year: Scalars['Int']['output'];
};

export type VehiclesWithFeatureInput = {
  equipcode: Scalars['String']['input'];
};

export type GetVehicleAncapTestRecordsQueryVariables = Exact<{
  vehicleId: Scalars['ID']['input'];
}>;


export type GetVehicleAncapTestRecordsQuery = { __typename?: 'Query', getVehicleAncapTestRecords?: { __typename?: 'AncapTestRecord', rating?: number | null, ratingYear?: string | null, technicalReportUrl?: string | null, ancapUrl: string, reportType: AncapReportType, protocolVersion?: string | null, gradingLabel?: GradingLabel | null, gradingYear?: string | null, isAncapValid?: boolean | null, testResults: Array<{ __typename?: 'AncapTestResult', name?: string | null, type?: string | null, value?: string | null, maxvalue?: string | null, units?: string | null, isassessed?: boolean | null }> } | null };

export type GetVehicleComfortFeaturesQueryVariables = Exact<{
  vehicleId: Scalars['ID']['input'];
}>;


export type GetVehicleComfortFeaturesQuery = { __typename?: 'Query', getVehicleComfortFeatures: Array<{ __typename?: 'VehicleComfortFeature', vehicleid: string, comfortfeaturecode?: string | null, comfortfeaturename?: string | null } | null> };

export type GetVehicleCostQueryVariables = Exact<{
  vehicleId: Scalars['ID']['input'];
}>;


export type GetVehicleCostQuery = { __typename?: 'Query', getVehicleCost?: { __typename?: 'VehicleCostData', vehicleid: string, fueltype?: string | null, fuelconsumption?: string | null, estimatedrunningcost?: number | null } | null };

export type GetVehicleEcoDataQueryVariables = Exact<{
  vehicleId: Scalars['ID']['input'];
}>;


export type GetVehicleEcoDataQuery = { __typename?: 'Query', getVehicleEcoData?: { __typename?: 'VehicleEcoData', airpollutionrating?: number | null, co2combined?: number | null, co2extraurban?: number | null, co2urban?: number | null, emissionstandard?: string | null, energyconsumption?: number | null, fuelcombined?: number | null, fuelextraurban?: number | null, fuelurban?: number | null, greenhouserating?: number | null, kmrangeelectricwltp?: number | null, powerplanttype?: string | null, vehicleid: string } | null };

export type GetAllSafetyFeaturesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllSafetyFeaturesQuery = { __typename?: 'Query', getAllSafetyFeatures: Array<{ __typename?: 'SafetyFeature', safetyfeaturecode: string, safetyfeaturename: string, isrecommended: boolean }> };

export type GetVehicleSearchFiltersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetVehicleSearchFiltersQuery = { __typename?: 'Query', getVehicleSearchFilters: { __typename?: 'VehicleSearchFilters', makes: Array<{ __typename?: 'VehicleSearchFilter', label: string, value: string }>, bodyTypes: Array<{ __typename?: 'VehicleSearchFilter', label: string, value: string }>, recommendedSafetyFeatures: Array<{ __typename?: 'VehicleSearchFilter', label: string, value: string }> } };

export type GetVehicleQueryVariables = Exact<{
  input: GetVehicleInput;
}>;


export type GetVehicleQuery = { __typename?: 'Query', getVehicle?: { __typename?: 'VehicleSearchResult', vehicleid: string, makeid: string, modelid: string, month: string, year: number, pplatestatus?: string | null, minprice?: number | null, maxprice?: number | null, makedescription: string, modeldescription: string, description: string, safecarforfamilies?: boolean | null, bodytype?: string | null, stars?: number | null, activeratingprovider?: string | null, isrecommendable?: boolean | null, safetyfeatures?: Array<string> | null, lifestyle?: Array<string> | null, photoId?: string | null, featuresRating?: string | null, safetyRating?: string | null, costRating?: string | null, ecoRating?: string | null, vfactssegment?: string | null } | null };

export type GetVehiclesWithFeatureQueryVariables = Exact<{
  input: VehiclesWithFeatureInput;
}>;


export type GetVehiclesWithFeatureQuery = { __typename?: 'Query', getVehiclesWithFeature: Array<{ __typename?: 'VehicleSearchResult', vehicleid: string, makeid: string, modelid: string, month: string, year: number, pplatestatus?: string | null, minprice?: number | null, maxprice?: number | null, makedescription: string, modeldescription: string, description: string, bodytype?: string | null, stars?: number | null, activeratingprovider?: string | null, ancaptestyear?: number | null, safetyfeatures?: Array<string> | null, photoId?: string | null }> };

export type GetVehiclesQueryVariables = Exact<{
  input: GetVehiclesInput;
}>;


export type GetVehiclesQuery = { __typename?: 'Query', getVehicles: Array<{ __typename?: 'VehicleSearchResult', vehicleid: string, makeid: string, modelid: string, month: string, year: number, pplatestatus?: string | null, minprice?: number | null, maxprice?: number | null, makedescription: string, modeldescription: string, description: string, safecarforfamilies?: boolean | null, bodytype?: string | null, stars?: number | null, activeratingprovider?: string | null, ancaptestyear?: number | null, isrecommendable?: boolean | null, safetyfeatures?: Array<string> | null, lifestyle?: Array<string> | null, photoId?: string | null, featuresRating?: string | null, safetyRating?: string | null, costRating?: string | null, ecoRating?: string | null, vfactssegment?: string | null, makeslug?: string | null, modelslug?: string | null }> };

export type GetYearsQueryVariables = Exact<{
  input: GetYearsInput;
}>;


export type GetYearsQuery = { __typename?: 'Query', getYears: Array<number> };

export type GetAllMakesModelsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllMakesModelsQuery = { __typename?: 'Query', getAllMakesModels: Array<{ __typename?: 'MakeModel', make: { __typename?: 'MakeModelItem', id: string, description: string }, models: Array<{ __typename?: 'MakeModelItem', id: string, description: string }> }> };

export type GetVehicleSafetyFeaturesQueryVariables = Exact<{
  vehicleId: Scalars['ID']['input'];
}>;


export type GetVehicleSafetyFeaturesQuery = { __typename?: 'Query', getVehicleSafetyFeatures: Array<{ __typename?: 'VehicleSafetyFeature', safetyfeaturecode?: string | null, safetyfeaturename?: string | null, isrecommended?: boolean | null, isprimaryfeature?: boolean | null, isstandard?: boolean | null } | null> };

export type GetVehicleSafetyFieldsByIdQueryVariables = Exact<{
  vehicleId: Scalars['ID']['input'];
}>;


export type GetVehicleSafetyFieldsByIdQuery = { __typename?: 'Query', getVehicleSafetyFieldsById?: { __typename?: 'VehicleSafetyFields', activeratingprovider?: string | null, ancaptestyear?: number | null, safetyFeatures?: Array<string> | null, stars?: number | null, vehicleid: string } | null };

export type SearchVehiclesQueryVariables = Exact<{
  input: VehicleSearchInput;
}>;


export type SearchVehiclesQuery = { __typename?: 'Query', searchVehicles: Array<{ __typename?: 'VehicleSearchResult', ancaptestyear?: number | null, vehicleid: string, makeid: string, makeslug?: string | null, modelid: string, modelslug?: string | null, month: string, year: number, pplatestatus?: string | null, minprice?: number | null, maxprice?: number | null, makedescription: string, modeldescription: string, description: string, safecarforfamilies?: boolean | null, bodytype?: string | null, stars?: number | null, activeratingprovider?: string | null, isblacklisted?: boolean | null, isrecommendable?: boolean | null, safetyfeatures?: Array<string> | null, lifestyle?: Array<string> | null, photoId?: string | null, featuresRating?: string | null, safetyRating?: string | null, costRating?: string | null, ecoRating?: string | null, vfactssegment?: string | null, isbaseoption?: boolean | null, transmission?: string | null, fueltype?: string | null, ucsrDriver?: number | null, ucsrPrimarySafety?: number | null, ucsrAggressivity?: number | null }> };

export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: NonNullable<DocumentTypeDecoration<TResult, TVariables>['__apiType']>;
  private value: string;
  public __meta__?: Record<string, any> | undefined;

  constructor(value: string, __meta__?: Record<string, any> | undefined) {
    super(value);
    this.value = value;
    this.__meta__ = __meta__;
  }

  override toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}

export const GetVehicleAncapTestRecordsDocument = new TypedDocumentString(`
    query getVehicleAncapTestRecords($vehicleId: ID!) {
  getVehicleAncapTestRecords(vehicleId: $vehicleId) {
    rating
    ratingYear
    technicalReportUrl
    ancapUrl
    reportType
    protocolVersion
    gradingLabel
    gradingYear
    isAncapValid
    testResults {
      name
      type
      value
      maxvalue
      units
      isassessed
    }
  }
}
    `) as unknown as TypedDocumentString<GetVehicleAncapTestRecordsQuery, GetVehicleAncapTestRecordsQueryVariables>;
export const GetVehicleComfortFeaturesDocument = new TypedDocumentString(`
    query getVehicleComfortFeatures($vehicleId: ID!) {
  getVehicleComfortFeatures(vehicleId: $vehicleId) {
    vehicleid
    comfortfeaturecode
    comfortfeaturename
  }
}
    `) as unknown as TypedDocumentString<GetVehicleComfortFeaturesQuery, GetVehicleComfortFeaturesQueryVariables>;
export const GetVehicleCostDocument = new TypedDocumentString(`
    query getVehicleCost($vehicleId: ID!) {
  getVehicleCost(vehicleId: $vehicleId) {
    vehicleid
    fueltype
    fuelconsumption
    estimatedrunningcost
  }
}
    `) as unknown as TypedDocumentString<GetVehicleCostQuery, GetVehicleCostQueryVariables>;
export const GetVehicleEcoDataDocument = new TypedDocumentString(`
    query getVehicleEcoData($vehicleId: ID!) {
  getVehicleEcoData(vehicleId: $vehicleId) {
    airpollutionrating
    co2combined
    co2extraurban
    co2urban
    emissionstandard
    energyconsumption
    fuelcombined
    fuelextraurban
    fuelurban
    greenhouserating
    kmrangeelectricwltp
    powerplanttype
    vehicleid
  }
}
    `) as unknown as TypedDocumentString<GetVehicleEcoDataQuery, GetVehicleEcoDataQueryVariables>;
export const GetAllSafetyFeaturesDocument = new TypedDocumentString(`
    query getAllSafetyFeatures {
  getAllSafetyFeatures {
    safetyfeaturecode
    safetyfeaturename
    isrecommended
  }
}
    `) as unknown as TypedDocumentString<GetAllSafetyFeaturesQuery, GetAllSafetyFeaturesQueryVariables>;
export const GetVehicleSearchFiltersDocument = new TypedDocumentString(`
    query GetVehicleSearchFilters {
  getVehicleSearchFilters {
    makes {
      label
      value
    }
    bodyTypes {
      label
      value
    }
    recommendedSafetyFeatures {
      label
      value
    }
  }
}
    `) as unknown as TypedDocumentString<GetVehicleSearchFiltersQuery, GetVehicleSearchFiltersQueryVariables>;
export const GetVehicleDocument = new TypedDocumentString(`
    query getVehicle($input: GetVehicleInput!) {
  getVehicle(input: $input) {
    vehicleid
    makeid
    modelid
    month
    year
    pplatestatus
    minprice
    maxprice
    makedescription
    modeldescription
    description
    safecarforfamilies
    bodytype
    stars
    activeratingprovider
    isrecommendable
    safetyfeatures
    lifestyle
    photoId
    featuresRating
    safetyRating
    costRating
    ecoRating
    vfactssegment
  }
}
    `) as unknown as TypedDocumentString<GetVehicleQuery, GetVehicleQueryVariables>;
export const GetVehiclesWithFeatureDocument = new TypedDocumentString(`
    query getVehiclesWithFeature($input: VehiclesWithFeatureInput!) {
  getVehiclesWithFeature(input: $input) {
    vehicleid
    makeid
    modelid
    month
    year
    pplatestatus
    minprice
    maxprice
    makedescription
    modeldescription
    description
    bodytype
    stars
    activeratingprovider
    ancaptestyear
    safetyfeatures
    photoId
  }
}
    `) as unknown as TypedDocumentString<GetVehiclesWithFeatureQuery, GetVehiclesWithFeatureQueryVariables>;
export const GetVehiclesDocument = new TypedDocumentString(`
    query getVehicles($input: GetVehiclesInput!) {
  getVehicles(input: $input) {
    vehicleid
    makeid
    modelid
    month
    year
    pplatestatus
    minprice
    maxprice
    makedescription
    modeldescription
    description
    safecarforfamilies
    bodytype
    stars
    activeratingprovider
    ancaptestyear
    isrecommendable
    safetyfeatures
    lifestyle
    photoId
    featuresRating
    safetyRating
    costRating
    ecoRating
    vfactssegment
    makeslug
    modelslug
  }
}
    `) as unknown as TypedDocumentString<GetVehiclesQuery, GetVehiclesQueryVariables>;
export const GetYearsDocument = new TypedDocumentString(`
    query getYears($input: GetYearsInput!) {
  getYears(input: $input)
}
    `) as unknown as TypedDocumentString<GetYearsQuery, GetYearsQueryVariables>;
export const GetAllMakesModelsDocument = new TypedDocumentString(`
    query getAllMakesModels {
  getAllMakesModels {
    make {
      id
      description
    }
    models {
      id
      description
    }
  }
}
    `) as unknown as TypedDocumentString<GetAllMakesModelsQuery, GetAllMakesModelsQueryVariables>;
export const GetVehicleSafetyFeaturesDocument = new TypedDocumentString(`
    query getVehicleSafetyFeatures($vehicleId: ID!) {
  getVehicleSafetyFeatures(vehicleId: $vehicleId) {
    safetyfeaturecode
    safetyfeaturename
    isrecommended
    isprimaryfeature
    isstandard
  }
}
    `) as unknown as TypedDocumentString<GetVehicleSafetyFeaturesQuery, GetVehicleSafetyFeaturesQueryVariables>;
export const GetVehicleSafetyFieldsByIdDocument = new TypedDocumentString(`
    query getVehicleSafetyFieldsById($vehicleId: ID!) {
  getVehicleSafetyFieldsById(vehicleId: $vehicleId) {
    activeratingprovider
    ancaptestyear
    safetyFeatures
    stars
    vehicleid
  }
}
    `) as unknown as TypedDocumentString<GetVehicleSafetyFieldsByIdQuery, GetVehicleSafetyFieldsByIdQueryVariables>;
export const SearchVehiclesDocument = new TypedDocumentString(`
    query searchVehicles($input: VehicleSearchInput!) {
  searchVehicles(input: $input) {
    ancaptestyear
    vehicleid
    makeid
    makeslug
    modelid
    modelslug
    month
    year
    pplatestatus
    minprice
    maxprice
    makedescription
    modeldescription
    description
    safecarforfamilies
    bodytype
    stars
    activeratingprovider
    isblacklisted
    isrecommendable
    safetyfeatures
    lifestyle
    photoId
    featuresRating
    safetyRating
    costRating
    ecoRating
    vfactssegment
    isbaseoption
    transmission
    fueltype
    ucsrDriver
    ucsrPrimarySafety
    ucsrAggressivity
  }
}
    `) as unknown as TypedDocumentString<SearchVehiclesQuery, SearchVehiclesQueryVariables>;